import * as type from "../types";
import {deleteReq, get, patch, post, put, remove} from "../../config/Requests";
import {setData} from '../helpers';
import {openSnackbarError, openSnackbarInfoDispatch} from "./requestAction";
import t from "../../languages/pl";
import axios from "../../config/axiosConfig";
import {tokenIdentifier} from '../../utils/staticData';
import {getToken} from '../../config/sessionData';
import {initialZones} from '../reducers/carsReducer';
import {
    carsChangesRoute,
    carsContractedMileageRoute,
    carsDamage,
    carsDamageImageUrl,
    carsDataRoute,
    carsEcoChartRoute,
    carsEvidenceRoute,
    carsGroupDeleteRoute,
    carsInsuranceRoute,
    carsListRoute,
    carsParametersListRoute,
    carsParametersRoute,
    carsPoolRoute,
    carsPricing,
    carsRemarksRoute,
    carsRentListRoute,
    carsRentRoute,
    carsReportsRoute,
    carsServiceInspectionRoute, carsServiceInspectionsResetRoute,
    carsServiceInspectionsRoute,
    carsSettingsRoute,
    carsSmsRoute,
    carsTechnicalInspectionRoute,
    carsWorkingHoursRoute,
    carsZonePoolRoute,
    carsZoneRoute
} from '../../config/routes';
import moment from "moment";

export const getCarsDetails = (description = "", address) => {
    return dispatch => {
        let params = {
            opis: description,
        };

        if (address) {
            params = {
                ...params,
                ulica: address.street,
                miasto: address.city,
                kod_pocztowy: address.postalCode,
                promien: address.radius
            };
        }

        get(
            dispatch,
            carsListRoute,
            params,
            response => {
                response.data[1].map(car => {
                    if (car.eco === 'b.d.') {
                        car.eco = -1;
                    }
                    if (car.dystans === 'b.d.') {
                        car.dystans = -1;
                    }

                });
                setData(dispatch, type.SET_CARS, response);
            },
        );
    };
};

export const removeCarFromGroup = (groupId, carId) => {
    return (dispatch, getState) => {
        let cars = getState().carsReducer.cars;
        let newCars = cars.map(car => {
            if (car.auto_id === carId)
                car.grupy = car.grupy.filter(group => group.grupa_id !== groupId);
            return car;
        });
        deleteReq(
            dispatch,
            carsGroupDeleteRoute,
            {auto_id: carId, grupa_id: groupId},
            () => {
                dispatch({
                    type: type.SET_CARS,
                    value: newCars
                });
            }
        );
    };
};

export const getZones = (id, defaultZone = false) => {
    let params = {
        auto_id: id,
        polska: defaultZone
    };

    return dispatch => {
        get(
            dispatch,
            carsZoneRoute,
            params,
            response => {
                setData(dispatch, type.SET_ZONES, response);
            },
        );
    };
};

export const patchZones = (ids, data) => {
    return dispatch => {
        patch(
            dispatch,
            carsZoneRoute,
            {auto_id: ids},
            {lista_rejon: data},
            () => openSnackbarInfoDispatch(dispatch, t.zonesUpdateSuccessMessage)
        );
    };
};

export const getPoolZones = (id, defaultZone = false) => {
    let params = {
        auto_id: id,
        polska: defaultZone
    };

    return dispatch => {
        get(
            dispatch,
            carsZonePoolRoute,
            params,
            response => {
                setData(dispatch, type.SET_ZONES, response);
            },
        );
    };
};


export const patchPoolZones = (ids, data) => {
    return dispatch => {
        patch(
            dispatch,
            carsZonePoolRoute,
            {auto_id: ids},
            {lista_rejon: data},
            () => openSnackbarInfoDispatch(dispatch, t.zonesUpdateSuccessMessage)
        );
    };
};

export const clearZones = () => {
    return dispatch => {
        dispatch({
            type: type.SET_ZONES,
            value: initialZones
        });
    };
};

export const getIndividualWorkingHours = (id) => {
    let params = {
        auto_id: id,
    };

    return dispatch => {
        get(
            dispatch,
            carsWorkingHoursRoute,
            params,
            response => {
                setData(dispatch, type.SET_INDIVIDUAL_WORKING_HOURS, response);
            },
        );
    };
};

export const patchIndividualWorkingHours = (id, privateWorkingHoursMode, startTime, endTime) => {
    return dispatch => {
        patch(
            dispatch,
            carsWorkingHoursRoute,
            {auto_id: id},
            {
                godzina_start: startTime,
                godzina_koniec: endTime,
                godziny_indywidualne: privateWorkingHoursMode
            },
            () => openSnackbarInfoDispatch(dispatch, t.workingHoursHasBeenUpdated)
        );
    };
};

export const getInsuranceDates = (id) => {
    let params = {
        auto_id: id,
    };

    return dispatch => {
        get(
            dispatch,
            carsInsuranceRoute,
            params,
            response => {
                setData(dispatch, type.SET_INSURANCE_DATE, response);
            },
        );
    };
};

export const patchInsuranceDate = (carId, date) => {
    return (dispatch, getState) => {
        let insurance = getState().carsReducer.insuranceDate;
        insurance.data_ubezpieczenia = date;
        patch(
            dispatch,
            carsInsuranceRoute,
            {auto_id: carId},
            {data_ubezpieczenia: date},
            () => {
                dispatch({
                    type: type.SET_INSURANCE_DATE,
                    value: insurance
                });
                openSnackbarInfoDispatch(dispatch, t.insurancePatchSuccessMsg);
            }
        );
    };
};

export const getInspections = (id) => {
    let params = {
        auto_id: id
    };

    return dispatch => {
        get(
            dispatch,
            carsTechnicalInspectionRoute,
            params,
            response => {
                setData(dispatch, type.SET_TECHNICAL_INSPECTIONS, response);
            }
        );

        get(
            dispatch,
            carsServiceInspectionRoute,
            params,
            response => {
                setData(dispatch, type.SET_SERVICE_INSPECTIONS, response);
            }
        );

        get(
            dispatch,
            carsServiceInspectionsRoute,
            {samochod_id: id},
            response => {
                setData(dispatch, type.SET_SERVICE_INSPECTIONS_HISTORY, response);
            }
        );
    };
};


export const postNewInspection = (inspection) => {

    return (dispatch, getState) => {
        post(
            dispatch,
            carsServiceInspectionsRoute,
            {
                samochod_id: inspection.samochod_id,
                dystans: inspection.dystans,
                opis: inspection.opis,
                data: moment(inspection.data).unix()
            }
            ,
            (response) => {

                const {history} = getState().carsReducer.inspections;
                const inspections = {
                    przeglady_serwisowe: [{
                        przeglad_id: response.data[1].przeglad_id,
                        dystans: inspection.dystans,
                        opis: inspection.opis,
                        data: moment(inspection.data).unix()
                    }, ...history.przeglady_serwisowe]
                };

                dispatch({
                    type: type.SET_SERVICE_INSPECTIONS_HISTORY,
                    value: inspections
                });
            }
        );
    };
};

export const updateInspection = (inspection) => {
    return (dispatch, getState) => {
        put(
            dispatch,
            carsServiceInspectionsRoute,
            {przeglad_id: inspection.przeglad_id},
            {
                dystans: inspection.dystans,
                opis: inspection.opis,
                data: moment(inspection.data).unix()
            }
            ,
            () => {

                const inspections = getState().carsReducer.inspections.history.przeglady_serwisowe;
                const tmpInspectioins = [...inspections];
                const idx = tmpInspectioins.findIndex(item => item.przeglad_id === inspection.przeglad_id);

                if (idx !== -1) {
                    tmpInspectioins[idx] = {
                        przeglad_id: inspection.przeglad_id,
                        dystans: inspection.dystans,
                        opis: inspection.opis,
                        data: moment(inspection.data).unix()
                    };

                    const tmp = {przeglady_serwisowe: []};
                    tmp.przeglady_serwisowe = [...tmpInspectioins];
                    dispatch({
                        type: type.SET_SERVICE_INSPECTIONS_HISTORY,
                        value: tmp
                    });
                }
            }
        );
    };
};

export const deleteInspection = (przeglad_id) => {

    return (dispatch, getState) => {
        remove(
            dispatch,
            carsServiceInspectionsRoute,
            {przeglad_id},
            () => {
                const {history} = getState().carsReducer.inspections;
                const idx = history.przeglady_serwisowe.findIndex(item => item.przeglad_id === przeglad_id);
                if (idx !== -1) {
                    const inspections = {
                        przeglady_serwisowe: history.przeglady_serwisowe.filter(item => item.przeglad_id !== przeglad_id)
                    };

                    dispatch({
                        type: type.SET_SERVICE_INSPECTIONS_HISTORY,
                        value: inspections
                    });
                }
            },
        );
    };
};

export const patchInspections = (carId, data) => {
    let query = {
        auto_id: carId
    };
    return (dispatch) => {
        patch(
            dispatch,
            carsTechnicalInspectionRoute,
            query,
            {data_przegladu: data.technical.data_przegladu},
            () => {
                dispatch({
                    type: type.SET_TECHNICAL_INSPECTIONS,
                    value: data.technical
                });
                openSnackbarInfoDispatch(dispatch, t.technicalInspectionsPatchSuccessMsg);
            }
        );

        patch(
            dispatch,
            carsServiceInspectionRoute,
            query,
            {
                przeglad_co: data.service.przeglad_co,
                przeglad_data: data.service.przeglad_data,
                informacja_przed: data.service.informacja_przed,
                informacja_po: data.service.informacja_po,
            },
            () => {
                dispatch({
                    type: type.SET_SERVICE_INSPECTIONS,
                    value: data.service
                });
                openSnackbarInfoDispatch(dispatch, t.serviceInspectionsPatchSuccessMsg);
            }
        );
    };
};

export const resetInspections = (carId) => {
    return (dispatch) => {
        post(
            dispatch,
            carsServiceInspectionsResetRoute,
            {
                auto_id: carId
            },
            () => {
                openSnackbarInfoDispatch(dispatch, t.serviceInspectionsPatchSuccessMsg);
            },
            () => {
                openSnackbarError(dispatch, t.serviceInspectionsPatchErrorMsg);
            }
        );
    };
};

export const patchContractedMileage = (carId, data) => {
    return dispatch => {
        patch(
            dispatch,
            carsContractedMileageRoute,
            {auto_id: carId},
            {
                data_od: data.poczatek_kontraktu,
                data_do: data.koniec_kontraktu,
                przebieg: data.zakontraktowany_przebieg
            },
            () => {
                openSnackbarInfoDispatch(dispatch, t.contractedMileageHasBeenUpdated);
            },
            error => {
                openSnackbarError(dispatch, error.data);
            }
        );
    };
};

export const getContractedMileage = id => {
    let params = {
        auto_id: id
    };

    return dispatch => {
        get(
            dispatch,
            carsContractedMileageRoute,
            params,
            response => {
                setData(dispatch, type.SET_CONTRACTED_MILEAGE, response);
            }
        );
    };
};

export const getData = (id, start = null, end = null) => {
    return dispatch => {

        let data = {
            auto_id: id,
            data_od: start,
            data_do: end
        };

        get(
            dispatch,
            carsDataRoute,
            data,
            response => {
                dispatch({
                    type: type.SET_DATA,
                    value: response.data
                });
            }
        );
    };
};

export const getCarReports = id => {
    return dispatch => {
        get(
            dispatch,
            carsReportsRoute,
            {auto_id: id},
            response => {
                setData(dispatch, type.SET_REPORTS_AND_NOTIFICATIONS, response);
            },
        );
    };
};

export const patchCarReports = (carId, data) => {
    return dispatch => {
        patch(
            dispatch,
            carsReportsRoute,
            {auto_id: carId},
            data,
            () => openSnackbarInfoDispatch(dispatch, t.reportSettingsHasBeenUpdated)
        );
    };
};

export const getDeviceSettings = id => {
    return dispatch => {
        get(
            dispatch,
            carsSettingsRoute,
            {auto_id: id},
            response => {
                setData(dispatch, type.SET_CAR_SETTINGS, response);
            }
        );
    };
};

export const patchDeviceSettings = (carId, data) => {
    return dispatch => {
        patch(
            dispatch,
            carsSettingsRoute,
            {auto_id: carId},
            data,
            () => openSnackbarInfoDispatch(dispatch, t.deviceSettingsHasBeenUpdated)
        );
    };
};

export const getSmsList = id => {
    return dispatch => {
        get(
            dispatch,
            carsSmsRoute,
            {auto_id: id},
            response => {
                setData(dispatch, type.SET_SMS, response);
            }
        );
    };
};

export const putSms = (carId, mode, value) => {
    const config = {
        headers: {
            [tokenIdentifier]: getToken()
        }
    };
    return (dispatch) => {
        return axios.put(
            carsSmsRoute,
            {
                auto_id: carId,
                [mode]: value === 1
            },
            config
        ).then(() => {
            dispatch(getSmsList(carId));
        });
    };
};

export const getCarParameters = id => {
    return dispatch => {
        get(
            dispatch,
            carsParametersRoute,
            {auto_id: id},
            response => {
                setData(dispatch, type.SET_CAR_PARAMETERS, response);
            }
        );
    };
};

export const patchCarParameters = (id, data) => {
    return (dispatch, getState) => {
        let cars = getState().carsReducer.cars;
        let updatedCar = cars.find(car => car.auto_id === id);

        const keys = Object.keys(data.toSend);
        for (const key in keys) {
            const value = keys[key];
            updatedCar[value] = data.toSend[value];
        }
        updatedCar.marka = data.toUpdate.marka;
        updatedCar.model = data.toUpdate.model;
        updatedCar.paliwo = data.toUpdate.paliwo;
        updatedCar.typ = data.toUpdate.typ;
        updatedCar.oczekiwane_sr_spalanie = data.toUpdate.oczekiwane_sr_spalanie;
        patch(
            dispatch,
            carsParametersRoute,
            {auto_id: id},
            data.toSend,
            () => {
                dispatch({
                    type: type.SET_CARS,
                    value: cars
                });
                openSnackbarInfoDispatch(dispatch, t.carParametersHasBeenUpdated);
            }
        );
    };
};

export const getCarDamage = id => {
    return dispatch => {
        get(
            dispatch,
            carsDamage,
            {auto_id: id},
            response => {
                dispatch({
                    type: type.SET_CAR_DAMAGE,
                    value: response.data[1].uszkodzenia
                });
            }
        );
    };
};

export const putCarDamage = (id, damage) => {
    return dispatch => {
        patch(
            dispatch,
            carsDamage,
            {auto_id: id},
            damage,
            () => {
                openSnackbarInfoDispatch(dispatch, t.carDamageHasBeenUpdated);
            }
        );
    };
};

export const getCarDamageImage = (id) => {
    return dispatch => {
        get(
            dispatch,
            carsDamageImageUrl,
            {obraz_id: id},
            response => {
                const tmp = response.data[1];

                dispatch({
                    type: type.SET_CAR_DAMAGE_IMAGE,
                    value: {obraz_id: tmp.obraz_id, obraz_b64: tmp.obraz_b64}
                });
            }
        );
    };
};

export const postCarDamageImage = (image) => {
    return dispatch => {
        post(
            dispatch,
            carsDamageImageUrl, {obraz_b64: image},
            (response) => {
                const {data: obraz_id} = response;
                dispatch({
                    type: type.SET_CAR_DAMAGE_IMAGE,
                    value: {
                        obraz_b64: image,
                        obraz_id: obraz_id
                    }
                });
            }
        );
    };
};

export const DeleteCarDamageImage = id => {
    return dispatch => {
        delete (
            dispatch,
                carsDamageImageUrl,
                {obraz_id: id},
                response => {
                    dispatch({
                        type: type.DELETE_CAR_DAMAGE_IMAGE,
                        value: response
                    });
                }
        );
    };
};

export const getCarEvidence = id => {
    return dispatch => {
        get(
            dispatch,
            carsEvidenceRoute,
            {auto_id: id},
            response => {
                setData(dispatch, type.SET_CAR_EVIDENCE, response);
            }
        );
    };
};

export const putCarEvidence = (id, data) => {
    return dispatch => {
        put(
            dispatch,
            carsEvidenceRoute,
            {auto_id: id},
            {
                ewidencja_poczatek: data.ewidencja_poczatek,
                ewidencja_koniec: data.ewidencja_koniec
            },
            () => {
                openSnackbarInfoDispatch(dispatch, t.carEvidencesChangedSuccessfully);
            }
        );
    };
};


export const getCarEcoChart = id => {
    return dispatch => {
        get(
            dispatch,
            carsEcoChartRoute,
            {auto_id: id},
            response => setData(dispatch, type.SET_CAR_ECO_CHART, response)
        );
    };
};

export const cleanCarChartData = () => {
    return dispatch => {
        dispatch({
            type: type.SET_CAR_ECO_CHART,
            value: []
        });
    };
};

export const getCarPossibleParameters = () => {
    return dispatch => {
        let config = {
            headers: {[tokenIdentifier]: getToken()},
        };

        axios.get(carsParametersListRoute, config)
            .then(response => setData(dispatch, type.SET_POSSIBLE_PARAMETERS, response));
    };
};

export const getRent = (carId, rentId) => {

    return dispatch => {
        const params = {
            auto_id: carId,
            wynajem_id: rentId
        };
        get(
            dispatch,
            carsRentRoute,
            params,
            response => {
                setData(dispatch, type.SET_CAR_RENT, response);
            }
        );
    };
};

export const addRent = (carId, data) => {
    return (dispatch, getState) => {
        const rentList = getState().carsReducer.rentList;
        const body = {
            ...data,
            auto_id: carId
        };
        post(
            dispatch,
            carsRentRoute,
            body,
            response => {
                const addedRent = {
                    data_do: response.data_do,
                    data_od: response.data_od,
                    dystans: response.dystans,
                    dystans_po: response.dystans_po,
                    dystans_przed: response.dystans_przed,
                    kierowca: body.klient.nazwa,
                    operator: response.operator,
                    opis: body.opis,
                    typ: response.typ,
                    ...response.data
                };
                const newRentList = [
                    ...rentList,
                    addedRent
                ];
                newRentList.sort(function (a, b) {
                    return b.data_od - a.data_od;
                });
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: newRentList
                });
                openSnackbarInfoDispatch(dispatch, t.rentHasBeedAdded);
            }
        );
    };
};

export const putRent = (carId, rentId, data) => {
    return (dispatch, getState) => {
        const params = {
            wynajem_id: rentId,
            auto_id: carId
        };
        let rentList = getState().carsReducer.rentList;
        let updatedRent = rentList.find(rent => rent.wynajem_id === rentId && (rent.typ === "Wynajem" || rent.typ === "Rezerwacja"));
        updatedRent.data_od = data.data_od;
        updatedRent.data_do = data.data_do === 0 ? "Data nieustalona" : data.data_do;
        updatedRent.opis = data.opis;
        updatedRent.kierowca = data.klient.nazwa;

        const index = rentList.indexOf(updatedRent);
        rentList[index] = updatedRent;
        put(
            dispatch,
            carsRentRoute,
            params,
            data,
            () => {
                rentList.sort(function (a, b) {
                    return b.data_od - a.data_od;
                });
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: rentList
                });
                openSnackbarInfoDispatch(dispatch, t.rentUpdatedSuccessfully);
            }
        );
    };
};

export const deleteRent = (carId, rentId) => {
    return (dispatch, getState) => {
        let rentList = getState().carsReducer.rentList;
        let newRentList = rentList.filter(rent => rent.wynajem_id !== rentId);
        deleteReq(
            dispatch,
            carsRentRoute,
            {wynajem_id: rentId, auto_id: carId},
            () => {
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: newRentList
                });
                openSnackbarInfoDispatch(dispatch, t.rentDeletedSuccessfully);
            }
        );
    };
};

export const getPool = (carId, rentId) => {
    return dispatch => {
        const params = {
            auto_id: carId,
            wynajem_id: rentId
        };
        get(
            dispatch,
            carsPoolRoute,
            params,
            response => {
                setData(dispatch, type.SET_CAR_POOL, response);
            }
        );
    };
};

export const addPool = (carId, data) => {
    return (dispatch, getState) => {
        let rentList = getState().carsReducer.rentList;
        const body = {
            data_od: data.data_od,
            data_do: data.data_do,
            cel_podrozy: data.cel_podrozy,
            kierowca_id: data.kierowca_id,
            auto_id: carId
        };
        post(
            dispatch,
            carsPoolRoute,
            body,
            response => {
                const addedRent = {
                    data_do: response.data_do,
                    data_od: response.data_od,
                    dystans: response.dystans,
                    dystans_po: response.dystans_po,
                    dystans_przed: response.dystans_przed,
                    kierowca: data.kierowca_nazwa,
                    operator: response.operator,
                    opis: data.cel_podrozy,
                    typ: response.typ,
                    ...response.data
                };
                const newRentList = [
                    ...rentList,
                    addedRent
                ];
                newRentList.sort(function (a, b) {
                    return b.data_od - a.data_od;
                });
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: newRentList
                });
            }
        );
    };
};

export const putPool = (carId, rentId, data) => {
    return (dispatch, getState) => {
        const params = {
            wynajem_id: rentId,
            auto_id: carId
        };
        const body = {
            data_od: data.data_od,
            data_do: data.data_do,
            cel_podrozy: data.cel_podrozy,
            kierowca_id: data.kierowca_id
        };
        let rentList = getState().carsReducer.rentList;
        let updatedPool = rentList.find(rent => rent.wynajem_id === rentId);
        const index = rentList.indexOf(updatedPool);

        updatedPool.data_od = data.data_od;
        updatedPool.data_do = data.data_do;
        updatedPool.opis = data.cel_podrozy;
        updatedPool.kierowca = data.kierowca_nazwa;
        rentList[index] = updatedPool;
        put(
            dispatch,
            carsPoolRoute,
            params,
            body,
            () => {
                rentList.sort(function (a, b) {
                    return b.data_od - a.data_od;
                });
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: rentList
                });
                openSnackbarInfoDispatch(dispatch, t.poolUpdatedSuccessfully);
            }
        );
    };
};


export const deletePool = (carId, rentId) => {
    return (dispatch, getState) => {
        let rentList = getState().carsReducer.rentList;
        let newRentList = rentList.filter(rent => rent.wynajem_id !== rentId);
        deleteReq(
            dispatch,
            carsPoolRoute,
            {wynajem_id: rentId, auto_id: carId},
            () => {
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: newRentList
                });
                openSnackbarInfoDispatch(dispatch, t.poolDeletedSuccessfully);
            }
        );
    };
};


export const getRentChanges = (rentId) => {
    return dispatch => {
        get(
            dispatch,
            carsChangesRoute,
            {wynajem_id: rentId},
            response => setData(dispatch, type.SET_CHANGES, response)
        );
    };
};

export const getRentRemarks = (rentId) => {
    return dispatch => {
        get(
            dispatch,
            carsRemarksRoute,
            {wynajem_id: rentId},
            response => setData(dispatch, type.SET_REMARKS, response)
        );
    };
};

export const getRentList = (id) => {
    return dispatch => {
        let params = {
            auto_id: id
        };
        get(
            dispatch,
            carsRentListRoute,
            params,
            response => setData(dispatch, type.SET_RENT_LIST, response)
        );
    };
};

export const putRentDate = (carId, rentId, dateType, value) => {
    return (dispatch, getState) => {
        let updatedRentList = getState().carsReducer.rentList;
        let updatedRent = updatedRentList.find(rent => rent.wynajem_id === rentId);
        const oryginalDateFrom = updatedRent.data_od;
        const oryginalDateTo = updatedRent.data_do;
        const index = updatedRentList.findIndex(rent => rent.wynajem_id === rentId);
        if (dateType === "data_od") {
            updatedRent.data_od = value;
        } else if (dateType === "data_do") {
            if (value === 0) {
                updatedRent.data_do = "Data nieustalona";
            } else {
                updatedRent.data_do = value;
            }
        }
        const data = {
            data_od: updatedRent.data_od,
            data_do: updatedRent.data_do === "Data nieustalona" ? 0 : updatedRent.data_do
        };
        put(
            dispatch,
            carsRentListRoute,
            {wynajem_id: rentId, auto_id: carId},
            {...data},
            () => {
                updatedRentList[index] = updatedRent;
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: updatedRentList
                });
                openSnackbarInfoDispatch(dispatch, t.dateHasBeenUpdated);
            },
            () => {
                updatedRent.data_od = oryginalDateFrom;
                updatedRent.data_do = oryginalDateTo;
                dispatch({
                    type: type.SET_RENT_LIST,
                    value: updatedRentList
                });
                openSnackbarError(dispatch, t.dateChangeError);
            }
        );
    };
};

export const getCarPricing = (carId) => {
    return dispatch => {
        let params = {
            auto_id: carId
        };
        get(
            dispatch,
            carsPricing,
            params,
            response => {
                setData(dispatch, type.SET_CAR_PRICING, response);
            }
        );
    };
};

export const updateCarPricing = (carId, pricingId) => {
    return dispatch => {
        const pricing = {
            cennik_id: pricingId
        };
        put(
            dispatch,
            carsPricing,
            {auto_id: carId},
            pricing,
            () => {
                dispatch({
                    type: type.SET_CAR_PRICING,
                    value: pricing
                });
                openSnackbarInfoDispatch(dispatch, t.assignedPricingToCar);
            }
        );
    };
};
